import { render, staticRenderFns } from "./BrandProfile.vue?vue&type=template&id=520d489d&"
import script from "./BrandProfile.vue?vue&type=script&lang=js&"
export * from "./BrandProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports